/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import patchAssetInAllPools from './helpers/patchAssetInAllPools';

export const setUsageAltText = createAsyncThunk(
  'products/setUsageAltText',
  async ({
    assetId,
    altText,
    productId,
    variantId,
  }, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const { data } = await sdk.assets.setUsageAltText({
        assetId,
        altText,
        ...(productId ? { productId } : {}),
        ...(variantId ? { variantId } : {}),
      });

      return { asset: data?.asset };
    } catch (error) {
      Logger.error(new Error('Failed to set usage alt text'), { error, assetId }, [
        'SetUsageAltTextFailed',
        { assetId: String(assetId) },
      ]);
      Toast('Failed to update alt text. Refresh and try again', { type: 'error' });
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(setUsageAltText.fulfilled, (state, { payload }) => {
    if (payload?.asset) {
      patchAssetInAllPools(state, payload.asset);
    }
  });
};
